import { put } from '@/axios'

export interface ICancelFollowRequest {
  following_id?: string
}

export const putCancelFollow = async (params: ICancelFollowRequest) => {
  const response = await put<null>(`/user/cancelFollow`, params)

  return response
}
